import React, { useState } from "react";
import { useQuery } from "@apollo/client";
import CommunicationModal from "./CommunicationModal";
import CommuniModal from "./CommuiModal";
import gqlPreAuth from "../../../gql/preAuth";
import "../styles/pre-auth.css";
import AppModal from "../../../components/AppModal";
import { MdAttachFile, MdDownload } from "react-icons/md";
import { Tooltip } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import claims from "../../../gql/claims";
import toast from "react-hot-toast";
import preAuth from "../../../gql/preAuth";
import { LuReply } from "react-icons/lu";
import { useParams } from "react-router-dom";
import AppButton from "../../../shared/AppButton";
import { useTranslation } from "react-i18next";
import AppTable from "../../../shared/AppTable";

const CommunicationDetails = ({ item, currentItem }) => {
  const [showCommunicationModal, setshowCommunicationModal] = useState(false);
  const [communicationId, setCommunicationId] = useState("");
  const [dataArray, setdataArray] = useState([]);
  const { id } = useParams();
  const { t } = useTranslation();

  const {
    loading: communicationLoading,
    error: communicationError,
    data: communicationData,
    refetch: communicationRefetch,
  } = useQuery(gqlPreAuth.GET_TRANSACTION_COMMUNICATIONS, {
    variables: {
      input: {
        transaction_id: currentItem?.transaction_id,
        request_name: "claims",
      },
    },
    fetchPolicy: "network-only",
  });

  function downloadBase64File(base64Data, fileName, fileType) {
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: fileType });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }

  const {
    loading: pollLoading,
    error: pollError,
    data: pollData,
    refetch: refetchPoll,
  } = useQuery(preAuth.PRE_AUTH_COMMUNICATION_POLL, {
    skip: true,
  });

  const pollClicked = () => {
    toast.loading("Requesting!");
    refetchPoll().then(async (res) => {
      toast.success(res?.data?.pollRequest?.message || "Request Successfully!");
      await communicationRefetch({
        input: {
          transaction_id: currentItem?.transaction_id,
          request_name: "preAuth",
        },
      });
    });
  };

  const flattenedData =
    communicationData?.listCommunicationsByTransactionId?.data?.flatMap(
      (mainItem) =>
        mainItem.payload.map((payloadItem) => ({
          ...payloadItem,
          mainId: mainItem.id,
          creator: mainItem.creator,
          timestamp: mainItem.timestamp,
          type: mainItem.type,
        })),
    ) || [];

  const columns = [
    {
      header: t("Date"),
      render: (row) => new Date(row.timestamp).toLocaleDateString("en-GB"),
    },
    { header: t("Type"), field: "type" },
    {
      header: t("Comment/File"),
      render: (row) =>
        row?.payload_comment ? (
          <span className="text-xs text-gray-700">{row.payload_comment}</span>
        ) : (
          <div className="flex items-center gap-2">
            <MdAttachFile className="text-gray-500" />
            <span className="text-[11px] truncate max-w-[150px]">
              {row?.payload_attachment?.payload_attachment_title}
            </span>
            <Tooltip title={t("Download")}>
              <span>
                <MdDownload
                  className="cursor-pointer hover:opacity-80 text-lg"
                  style={{ color: "#0070C2" }}
                  onClick={() =>
                    downloadBase64File(
                      row?.payload_attachment?.payload_attachment_data,
                      row?.payload_attachment?.payload_attachment_title,
                      row?.payload_attachment?.payload_attachment_content_type,
                    )
                  }
                />
              </span>
            </Tooltip>
          </div>
        ),
    },
    {
      header: t("Item Seq."),
      render: (row) => {
        const findSeq = item?.getClaimTransaction?.data?.items?.find(
          (i) => i.sequence_no === row?.item_sequence,
        );
        return findSeq
          ? `${findSeq?.type} - (${findSeq?.standard_code})`
          : "___";
      },
    },
    {
      header: t("Reply"),
      align: "center",
      render: (row) =>
        row?.creator === "payer" ? (
          <Tooltip title={t("Reply")}>
            <div
              onClick={() => {
                setCommunicationId(row.mainId);
                setshowCommunicationModal(true);
              }}
              className="text-xl cursor-pointer hover:scale-110 transition-transform"
              style={{ color: "#0070C2" }}
            >
              <LuReply />
            </div>
          </Tooltip>
        ) : null,
    },
  ];

  return (
    <>
      <div className="pre_auth_communication_page !mt-2">
        {/* Header */}
        <div className="flex justify-end gap-3 mb-2">
          <AppButton
            label={t("Add Communication")}
            startIcon={<AddIcon />}
            onClick={() => setshowCommunicationModal(!showCommunicationModal)}
          />
        </div>

        {/* Table */}
        <AppTable
          columns={columns}
          data={flattenedData}
          loading={communicationLoading}
          actions={false}
        />

        <CommuniModal
          dataArray={dataArray}
          item={item}
          currentItem={currentItem}
          setdataArray={setdataArray}
          showCommunicationModal={showCommunicationModal}
          setshowCommunicationModal={setshowCommunicationModal}
          communicationId={communicationId}
          communicationRefetch={communicationRefetch}
        />
      </div>
    </>
  );
};

export default CommunicationDetails;
